import { Injectable } from '@angular/core';
import { INDDReportUserProvider } from '@ndk/ng-reports';

import { AuthTokenService } from '@core/authentication/auth-token.service';

/* Serviço utilizado para pegar a chave única do usuário autenticado */
@Injectable()
export class ReportNewCurrentUserService implements INDDReportUserProvider {
    constructor(private authenticationTokenService: AuthTokenService) { }

    public getUserId(): string {
        return this.authenticationTokenService.token.userid;
    }
}
